import React, { Component } from 'react'
import Container from '@mui/material/Container'
import CssBaseline from '@mui/material/CssBaseline'
import Typography from '@mui/material/Typography'
import { Button } from '@mui/material'
import Slide from '@mui/material/Slide'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import FormGroup from '@mui/material/FormGroup'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import AccountCircle from '@mui/icons-material/AccountCircle'
import { round } from 'lodash'

// Components
import HeadGlobal from './headerGlobal'

// Utils
// import { saving } from '../data/saveSurvey'
import { postFireData } from '../data/saveSurvey'
import {
  welcomeEs,
  welcomeFr,
  welcomeEn,
  welcomePtg,
} from '../textApp/textTrad'
import { navigationGA } from '../data/GA'

class EndSurvey extends Component {
  constructor(props) {
    super(props)

    this.state = {
      branded: '',
      age: '',
      gender: '',
      csp: '',
    }
    this.handleInput = this.handleInput.bind(this)
    this.handleEndSurvey = this.handleEndSurvey.bind(this)
  }

  static getDerivedStateFromProps() {
    navigationGA('Personal Data', 'perso', 'endsurvey')
    return null
  }
  selectLang = () => {
    const { lng } = this.props
    switch (lng) {
      case 'es':
        return welcomeEs
      case 'fr':
        return welcomeFr
      case 'en':
        return welcomeEn
      case 'pt':
        return welcomePtg
      default:
        return welcomeEn
    }
  }
  handleInput = (e) => {
    const { answers, setAns } = this.props
    const { name, value } = e.target
    this.setState({
      [name]: value,
    })
    setAns({ ...answers, [name]: value })
  }
  handleEndSurvey = () => {
    const convertAge = (age) => {
      switch (true) {
        case age < 25:
          return '18_24'
        case age > 24 && age < 35:
          return '25_34'
        case age > 34 && age < 50:
          return '35_49'
        case age > 49:
          return '50_65'
        default:
          return 'noAge'
      }
    }
    const { age, gender, csp } = this.state
    if (age && gender && csp) {
      const user = JSON.parse(localStorage.getItem('dataUser'))
      const { started } = user
      const dateEndSurvey = Date.now()
      const { answers, navigate, setEnd, location } = this.props
      const { age } = this.state
      const paramsList = new URLSearchParams(location.search)
      const ag = paramsList.get('ag')
      ///////// LOCAL OR STATE DATA /////////
      const brand = answers.brand || user.brand
      const socDis = answers.socDis || user.socDis
      const catego = answers.catego || user.catego
      const brandUsed = answers.brandUsed || user.brandUsed
      const userId = answers.userId || user.id
      const cntry = user.cntry
      const gender = answers.gender || user.gender
      const finalAge = answers.age || user.age || age
      const rangeAge = answers.rangeAge || user.rangeAge
      const rangeAge2 = convertAge(age)
      ///////// END LOCAL OR STATE DATA /////////
      setEnd(dateEndSurvey)
      const diff = dateEndSurvey - started
      const timeSurv = round(diff / 1000 / 60, 3)
      const device = navigator.userAgent
      const type = answers.col4Blu ? answers : user
      const finalAns = {
        ...type,
        ageLink: ag,
        age: finalAge,
        cntry: cntry,
        gender: gender,
        rangeAge: rangeAge == 'noAge' ? rangeAge2 : rangeAge,
        brand: brand,
        socDis: socDis,
        catego: catego,
        brandUsed: brandUsed,
        userId: userId,
        completed: true,
        device: device,
        timeSurvey: timeSurv,
        start: new Date(started).toString(),
        end: new Date(dateEndSurvey).toString(),
      }
      if (timeSurv < 5) {
        // navigate('/noSurvey')
        // setTimeout(() => {
        //   window.location.replace(
        //     'https://transit.nicequest.com/transit/participation?tp=qf_0&c=ok&ticket=' +
        //       userId
        //   )
        // }, 6000)
        setTimeout(() => {
          localStorage.removeItem('dataUser')
        }, 2000)
      } else {
        postFireData(finalAns, user.cntry)
        navigationGA('Save Survey', 'save', 'save')
        localStorage.setItem('dataUser', JSON.stringify({ existUser: true }))
        // navigate('/noSurvey')
        // setTimeout(() => {
        //   window.location.replace(
        //     'https://transit.nicequest.com/transit/participation?tp=co_0&c=ok&ticket=' +
        //       userId
        //   )
        // }, 6000)
        setTimeout(() => {
          localStorage.removeItem('dataUser')
        }, 2000)
      }
    } else {
      alert('Por favor indica los datos de edad género y ocupación')
    }
  }
  render() {
    // console.log('data', this.props)
    const { gender, csp, age } = this.state
    const { setlang, user } = this.props
    const txt = this.selectLang()

    const cspList = [
      {
        label: txt.agric,
        value: 'agric',
        name: 'csp',
      },
      {
        label: txt.comerce,
        value: 'comerce',
        name: 'csp',
      },
      {
        label: txt.chef,
        value: 'chef',
        name: 'csp',
      },
      {
        label: txt.employ,
        value: 'employ',
        name: 'csp',
      },
      {
        label: txt.ouvrier,
        value: 'ouvrier',
        name: 'csp',
      },
      {
        label: txt.retaite,
        value: 'retaite',
        name: 'csp',
      },
      {
        label: txt.student,
        value: 'student',
        name: 'csp',
      },
      {
        label: txt.inactif,
        value: 'inactif',
        name: 'csp',
      },
    ]
    return (
      <div className='center'>
        <div className='main'>
          <CssBaseline>
            <HeadGlobal setlang={setlang} changeLang={true} />
          </CssBaseline>
          <Typography
            component='h2'
            variant='h4'
            align='center'
            sx={{
              fontWeight: '700',
              fontSize: {
                xs: '1.5rem',
                sm: '1.5rem',
                md: '1.8rem',
              },
            }}
          >
            {txt.title1End} {user}
            {txt.title2End}
          </Typography>
          <Slide
            direction='right'
            in={true}
            mountOnEnter
            unmountOnExit
            timeout={700}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              maxWidth: '100% !important',
            }}
          >
            <Container
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyItems: 'flex-start',
                borderBottom: '2px solid #ccc',
                color: '#1976d2',
                flexDirection: 'row',
              }}
            >
              {/* /////////////// 
              ///// Age ///// 
              /////////////// */}
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  padding: '2vh 5vw 1vh 5vw',
                }}
              >
                <div className='lblSocioDem'>{txt.ageUser}</div>
                <AccountCircle
                  sx={{ color: 'action.active', mr: 5, my: 1.5 }}
                />
                <TextField
                  fullWidth
                  id='input-with-sx'
                  label={txt.ageLabel}
                  type='number'
                  onChange={this.handleInput}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant='standard'
                  name='age'
                  value={age}
                />
              </Box>
              {/* /////////////// 
              ///// GENDER ///// 
              /////////////// */}
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <div className='lblSocioDem'>{txt.genderUser}</div>
                <FormControl
                  sx={{ m: 1, width: '50%' }}
                  component='fieldset'
                  variant='standard'
                  required
                  width='40%'
                >
                  <FormGroup>
                    <FormControlLabel
                      sx={{
                        ' & .css-ahj2mt-MuiTypography-root': {
                          fontSize: { xs: '1.2rem', md: '1.3rem' },
                          textAlign: 'left',
                        },
                      }}
                      control={
                        <Checkbox
                          checked={gender === 'woman' ? true : false}
                          onChange={this.handleInput}
                          name='gender'
                          value='woman'
                        />
                      }
                      label={txt.genB}
                    />
                    <FormControlLabel
                      sx={{
                        ' & .css-ahj2mt-MuiTypography-root': {
                          fontSize: { xs: '1.2rem', md: '1.3rem' },
                          textAlign: 'left',
                        },
                      }}
                      control={
                        <Checkbox
                          checked={gender === 'man' ? true : false}
                          onChange={this.handleInput}
                          name='gender'
                          value='man'
                        />
                      }
                      label={txt.genA}
                    />
                    <FormControlLabel
                      sx={{
                        ' & .css-ahj2mt-MuiTypography-root': {
                          fontSize: { xs: '1.2rem', md: '1.3rem' },
                          textAlign: 'left',
                        },
                      }}
                      control={
                        <Checkbox
                          checked={gender === 'noBinary' ? true : false}
                          onChange={this.handleInput}
                          name='gender'
                          value='noBinary'
                        />
                      }
                      label={txt.genC}
                    />
                  </FormGroup>
                </FormControl>
              </Box>
              {/* /////////////// 
              ///// CSP ///// 
              /////////////// */}
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <div className='lblSocioDem'>{txt.cspUser}</div>
                <FormControl
                  sx={{ m: 3 }}
                  component='fieldset'
                  variant='standard'
                  required
                >
                  <FormGroup>
                    {cspList.map((itm, indx) => {
                      return (
                        <FormControlLabel
                          key={indx}
                          sx={{
                            ' & .css-ahj2mt-MuiTypography-root': {
                              fontSize: { xs: '1.2rem', md: '1.3rem' },
                              textAlign: 'left',
                            },
                          }}
                          control={
                            <Checkbox
                              checked={csp === itm.value ? true : false}
                              onChange={this.handleInput}
                              name={itm.name}
                              value={itm.value}
                            />
                          }
                          label={itm.label}
                        />
                      )
                    })}
                  </FormGroup>
                </FormControl>
              </Box>
            </Container>
          </Slide>
          {/* //////
          BOUTON NEXT
          //////////  */}
          <Button
            onClick={this.handleEndSurvey}
            variant='contained'
            sx={{
              marginTop: '1vh',
              padding: {
                xs: '1rem 4rem',
                sm: '1rem 2rem',
                md: '1rem 2rem',
              },
              fontSize: {
                xs: '1.2rem',
                sm: '1.5rem',
                md: '1.7rem',
              },
            }}
          >
            {txt.finish}
          </Button>
        </div>
      </div>
    )
  }
}
export default EndSurvey
